import {memo} from 'react'
import {useTreeDocContext} from '@/components/TreeDoc/index.mjs'

const NodeContent = ({node, ...props}) => {
    const map = useTreeDocContext()

    return (
        <div {...props}>
            <map.components.NodeOuterBox node={node} />
        </div>
    )
}

const MemorizedNodeContent = memo(NodeContent, () => true)
MemorizedNodeContent.displayName = 'NodeContent'

export default MemorizedNodeContent
